'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _notificationUtils = require('../../../../../../common/notifications/notificationUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanStorageDetailSection = function PlanStorageDetailSection(_ref) {
    var elementCount = _ref.elementCount;

    if (!elementCount) return null;

    var countDetail = (0, _notificationUtils.describeElementTypes)(elementCount.toJS());

    return _react2.default.createElement(
        'section',
        null,
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'p',
                { className: 'section-title' },
                'Unlimited storage'
            ),
            _react2.default.createElement(
                'p',
                { className: 'usage' },
                'You\'ve added ',
                countDetail
            )
        )
    );
};

PlanStorageDetailSection.propTypes = {
    elementCount: _propTypes2.default.object
};

exports.default = PlanStorageDetailSection;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/plan/pro/planSections/PlanStorageDetailSection.js
// module id = 2072
// module chunks = 0